import CrudRepository from './CrudRepository'

export default class AboutusRepository extends CrudRepository {
  constructor () {
    super('about-us')
  }
}
